import "../LanguagePicker/LanguagePicker.scss";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  THEMES,
  getTheme,
  setTheme,
  subscribeToTheme,
} from "../../theme/theme";

// Switches the skin right away (and saves it on the account). Same look as
// the language picker.
function ThemePicker() {
  const { t } = useTranslation();
  const [theme, setThemeState] = useState(getTheme);

  useEffect(() => subscribeToTheme(setThemeState), []);

  return (
    <div className="language-picker" role="radiogroup">
      {THEMES.map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={theme === option}
          className={`language-picker__option ${theme === option ? "is-active" : ""}`}
          onClick={() => setTheme(option)}
        >
          {t(`settings.themes.${option}`)}
        </button>
      ))}
    </div>
  );
}

export default ThemePicker;
